export default __webpack_public_path__ + "static/media/pencil.c1a8b2a0.svg";